export default __webpack_public_path__ + "static/media/B122.61c7fd22.png";